export default __webpack_public_path__ + "42075d2e97c08697e13be49bb0e43bb9.png";